// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__26I6Z","toggle":"styles_toggle__2v0QB","preview":"styles_preview__3JDIK"};